app.config(function ($stateProvider, $urlRouterProvider) {
    $stateProvider
    //Login Modules
        .state('landing', {
            url: '/landing?clinicCode',
            params: {clinicCode: {dynamic: true}},
            templateUrl: 'landing.html',
            controller: 'TransferFormController',
            resolve: {
                login: function (SessionService) {
                    return SessionService.getClosingClinicList();
                }
            }
        });
    $urlRouterProvider.otherwise('/landing');
});